import React from 'react';
import moment from 'moment';
import * as R from 'ramda';
import { string, func, object } from 'prop-types';

import { DropdownWithDotsS, Header } from '../styled-components';
import { ActionDropdown } from '../action-dropdown';
import { getAvatarUrl } from '../../../utils';
import { AssigneeWrapper, AvatarImageS, TaskWrapper, Title } from './styled-components';
import { ReactQuillWrapped } from '../../../components/react-quill';
import TaskPriority from '../../../components/task-item/task-priority';
import { TASK_PRIORITIES } from '../../../api/constants';

const Task = ({
  onToggleEditTaskForm,
  onDeleteTask,
  taskPriority,
  description,
  assignedTo,
  dueDate,
  title,
  users,
  _id,
}) => {
  const getTaskPriority = priority => R.find(({ value }) => value === priority, TASK_PRIORITIES);
  return (
    <TaskWrapper>
      <Header>
        <Title>{title}</Title>
        <DropdownWithDotsS
          overlay={ActionDropdown({
            onDelete: () => onDeleteTask(_id),
            onEdit: () => onToggleEditTaskForm(_id),
          })}
        />
      </Header>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignContent: 'center',
        }}
      >
        {dueDate && (
          <p style={{ margin: 0 }}>
            Deadline: <em>{moment(dueDate).format('DD/MM/YYYY')}</em>
          </p>
        )}
        <TaskPriority priority={getTaskPriority(taskPriority)} />
      </div>
      <ReactQuillWrapped theme={null} value={description} readOnly />
      <AssigneeWrapper>
        <AvatarImageS
          width={24}
          height={24}
          src={getAvatarUrl(R.path([assignedTo, 'profileImage'], users))}
        />
        <em>{R.prop('fullName', assignedTo)}</em>
      </AssigneeWrapper>
    </TaskWrapper>
  );
};

Task.propTypes = {
  onToggleEditTaskForm: func.isRequired,
  onDeleteTask: func.isRequired,
  assignedTo: string.isRequired,
  title: string.isRequired,
  users: object.isRequired,
  _id: string.isRequired,
  taskPriority: string.isRequired,
  description: string,
  dueDate: string,
};

Task.defaultProps = {
  description: '',
  dueDate: '',
};

export { Task };



// WEBPACK FOOTER //
// ./src/modals/add-meeting-notes-modal/task/index.js